export default __webpack_public_path__ + "static/features-android-app-lg-1f4b35033d25bfcbcc45abb935e24695.jpg";